import { getHeader } from '@/env';

const state = {
  addresses: [],
  addressesReturn: [],
  addressesShip: [],
  address: {},
  filters: {
    customerID: '',
    locationName: '',
    company: '',
    page: '',
    searchAddress: '',
    pageAddress: '',
  },
};

const mutations = {
  CLEAR_ADDRESS_STORE(state) {
    state.addresses = [];
    state.addressesReturn = [];
    state.addressesShip = [];
    state.address = {};
    state.filters = {};
  },
  FETCH(state, { list }) {
    state.addresses = list;
  },
  FETCH_RETURN(state, { list }) {
    state.addressesReturn = list;
  },
  FETCH_SHIP(state, { list }) {
    state.addressesShip = list;
  },
  CREATE(state, { data }) {
    state.addresses.data.push(data);
  },
  CREATE_SHIP(state, { data }) {
    state.addressesShip.data.push(data);
  },
  READ(state, { data }) {
    state.address = data;
  },
  UPDATE(state, { data }) {
    const idx = state.addresses.data.map((item) => item.id).indexOf(data.id);
    state.addresses.data.splice(idx, 1, data);
  },
  DELETE(state, { id }) {
    const idx = state.addresses.data.map((item) => item.id).indexOf(id);
    state.addresses.data.splice(idx, 1);
  },
  STORE_FILTERS(state, { data }) {
    state.filters = data;
  },
};

const actions = {
  clearAddressStore: ({ commit }) => {
    commit('CLEAR_ADRESS_STORE');
  },
  async fetch({ commit }) {
    try {
      const response = await axios.get('/api/addresses', { headers: getHeader() });
      commit('FETCH', { list: response.data });
    } catch (error) {

    }
  },
  async fetchByCustomer({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/customer', data, { headers: getHeader() });
      commit('FETCH', { list: response.data });
    } catch (error) {

    }
  },
  async fetchByCustomerReturn({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/customerreturn', data, { headers: getHeader() });
      commit('FETCH_RETURN', { list: response.data });
    } catch (error) {

    }
  },
  async fetchByCustomerShip({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/customership', data, { headers: getHeader() });
      commit('FETCH_SHIP', { list: response.data });
    } catch (error) {

    }
  },
  async create({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/create', data, { headers: getHeader() });
      commit('CREATE', { data: response.data });
    } catch (error) {

    }
  },
  async createShip({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/create', data, { headers: getHeader() });
      commit('CREATE_SHIP', { data: response.data });
    } catch (error) {

    }
  },
  async read({ commit }, id) {
    try {
      const response = await axios.get(`/api/addresses/${id}`, { headers: getHeader() });
      commit('READ', { data: response.data });
    } catch (error) {

    }
  },
  async update({ commit }, data) {
    try {
      const response = await axios.put(`/api/addresses/update/${data.id}`, data, { headers: getHeader() });
      commit('UPDATE', { data: response.data });
    } catch (error) {

    }
  },
  async delete({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/delete', data, { headers: getHeader() });
      commit('DELETE', { id: data.id });
    } catch (error) {

    }
  },
  async query({ commit }, data) {
    try {
      const response = await axios.post('/api/addresses/query', data, { headers: getHeader() });
      commit('FETCH', { list: response.data });
    } catch (error) {

    }
  },
  storeFilters: ({ commit }, data) => {
    commit('STORE_FILTERS', { data });
  },
};

const getters = {
  getFilters: (state, getters) => state.filters,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
